<template>
  <div class="container-fluid">
    <div class="card card-default custom-card-height">
      <div class="card-header feature-header">
        <div class="row g-2">
          <div class="col-auto me-auto">
            <CardTitleComponent />
          </div>
          <div class="col-auto">
            <SearchComponent v-model="searchText" @search="onSearch" @clear="clearSearch" />
          </div>
          <div class="col-auto">
            <SubscriptionCommonComponent v-if="isHost()" @on-subscription="onSubscriptionChange" />
          </div>
          <div class="col-auto">
            <a class="btn btn-outline-primary" @click="open(true)">
              <i class="fas fa-plus me-1"></i>{{ $t("addNew") }}
            </a>
          </div>
        </div>
      </div>
      <div class="card-body p-2">
        <div class="card-body-grid">
          <ejs-grid ref="gridUser" :dataSource="data" :allowPaging="true" :allowResizing="true"
            :pageSettings="pageSettings" :locale="locale" :rowHeight="38" :allowSorting="true"
            :searchSettings="searchOptions" :dataStateChange="dataStateChange">
            <e-columns>
              <e-column v-if="isHost()" :headerText="$t('organization') + ' ' + $t('name')"
                field="organizationName"></e-column>

              <e-column :headerText="$t('user') + ' ' + $t('name')" field="dbUserId"></e-column>
              <e-column :headerText="$t('password')" field="dummyPassword" :template="'passwordColumnTemplate'">
                <template v-slot:passwordColumnTemplate="{ data }">
                  <a class="copy-icon" v-if="
                    data.dbUserPassword &&
                    data.dbUserPassword.length > 0
                  " href="#" data-bs-toggle="tooltip" :title="$t('copy')">
                    <i class="fas fa-copy" @click="copyToClipboard(data.dbUserPassword)"></i> </a><span
                    v-if="data.dummyPassword">{{
                      data.dummyPassword
                    }}</span>
                </template>
              </e-column>

              <e-column :headerText="$t('allowedIPs')" field="allowedIPs"></e-column>

              <e-column :headerText="$t('User Type')" field="userType"></e-column>

              <e-column :headerText="$t('actions')" width="75" textAlign="Center" :template="'actionTemplate'">
                <template v-slot:actionTemplate="{ data }">
                  <div class="btn-group actions-row" role="group" aria-label="Basic example">
                    <a href="javascript:void(0)" class="ms-2 action-link action-edit" title="Edit"
                      @click="commandClick('Edit', data)">
                      <i class="e-edit e-icons" style="font-size: 0.76em;"></i>
                    </a>
                    <a href="javascript:void(0)" class="ms-2 action-link action-delete" title="Delete"
                      @click="commandClick('Delete', data)">
                      <i class="e-delete e-icons" style="font-size: 0.76em;"></i>
                    </a>
                  </div>
                </template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="userModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t("database") + " " + $t("user") }}</h4>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" @click="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit="onUpsert">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("customer") }}
                    <span class="text-danger">*</span></label>
                  <ejs-dropdownlist id="customerdd" ref="customerdd" v-model="form.subscriptionId"
                    :dataSource="listSubscription" :fields="fieldsSubscription" :placeholder="$t('msgSelectCustomer')"
                    @select="onSelectCustomer" :enabled="!isUpdate">
                  </ejs-dropdownlist>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("user") + " " + $t("type") }}
                    <span class="text-danger">*</span></label>
                  <ejs-dropdownlist id="dbUserdd" ref="dbUserdd" v-model="form.userType" :dataSource="listUserType"
                    :fields="fieldsUserType" :placeholder="$t('msgSelectUserType')" @select="onSelectCustomer" required>
                  </ejs-dropdownlist>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("username") }}
                    <span class="text-danger">*</span></label>
                  <input type="text" class="form-control input-sm" v-model="form.dbUserId" required
                    :readonly="isUpdate" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("password") }}
                    <span class="text-danger">*</span></label>
                  <div class="position-relative">
                    <input :type="showPassword ? 'text' : 'password'" class="form-control input-sm"
                      v-model="form.dbUserPassword" required style="padding-right: 2.2rem !important;" />
                    <span class="password-toggle-icon" @click="togglePasswordVisibility">
                      <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("allowedIPs") }}</label>
                  <input type="text" class="form-control input-sm" v-model="form.allowedIPs" />
                </div>
              </div>
            </div>
            <div class="row" v-if="form.userType == 'StagingEditor'">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("table permission") }}
                    <span class="text-danger">*</span></label>
                  <div style="max-height: calc(100vh - 390px); overflow: auto">
                    <CustomTreeView :dataSource="treeViewData"
                      :fields="{ id: 'id', pid: 'pid', text: 'text', hasChildren: 'hasChild' }"
                      v-model="scopeTreeSelectedNodes" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-outline-close" @click="close()">
              <i class="fas fa-times"></i>&nbsp;{{ $t("close") }}
            </button>
            <button type="submit" class="btn btn-sm btn-outline-info-reverse"
              :disabled="form.subscriptionId == '' || form.userType == ''">
              <i class="fas fa-save"></i>&nbsp;{{ isUpdate ? $t("update") : $t("save") }}
            </button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>
<script lang="ts">
import './DatabaseUserComponent.css';
import modal from "@/components/common/modalManage";
import { Lookup } from "@/components/pagebuilder/models/common.model";
import agent, { masterServiceBaseURL } from "@/services/agent";
import authService from "@/services/authService";
import toasterService from "@/services/toasterService";
import { L10n, setCulture } from "@syncfusion/ej2-base";
import { DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";
import {
  ColumnDirective as EColumn,
  ColumnsDirective as EColumns,
  GridComponent as EjsGrid,
  Group,
  Page,
  Resize,
  Search,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-vue-grids";
import CustomTreeView from "@/components/shared/treeview/CustomTreeView.vue";
import { DialogUtility } from "@syncfusion/ej2-vue-popups";
import { defineComponent } from "vue";
import { Subscription } from "../Subscription/Subscription.model";
import SubscriptionCommonComponent from "../Subscription/SubscriptionCommonComponent.vue";
import { API_KEY, DBUserType } from "./constant";
import {
  DatabaseUser,
  PropertyUser,
  SubscriptionGetResponse,
  UserGetResponse,
  UserResponse,
} from "./DatabaseUser.model";
import CardTitleComponent from '@/components/common/CardTitleComponent.vue';
import SearchComponent from '@/components/shared/SearchComponent.vue';
import _ from "lodash";

let _userData: PropertyUser = {} as PropertyUser;
let _userForm: DatabaseUser = {} as DatabaseUser;
let _subscriptionData: Subscription[] = [];
let _dbUserType: Lookup<number>[] = [];
let Confirmation: any = undefined;

export default defineComponent({
  components: {
    "ejs-grid": EjsGrid,
    "e-columns": EColumns,
    "e-column": EColumn,
    "ejs-dropdownlist": DropDownListComponent,
    SubscriptionCommonComponent,
    CardTitleComponent,
    SearchComponent,
    CustomTreeView,
  },
  provide: {
    grid: [Toolbar, Resize, Page, Sort, Group],
  },
  created() {
    agent.setBaseUrl(masterServiceBaseURL);

    this.gridLocalize();
  },
  data() {
    return {
      headers: {},
      listSubscription: _subscriptionData,
      listUserType: _dbUserType,
      fieldsRole: { text: "name", value: "id" },
      fieldsSubscription: { text: "organizationName", value: "id" },
      fieldsUserType: { text: "name", value: "name" },
      data: _userData,
      form: _userForm,
      isUpdate: false,
      confirmTitle: "",
      confirmIsDelete: false,
      selectedState: null,
      subscriptionId: "",
      searchText: "",
      searchOptions: {
        fields: ["FirstName", "LastName", "Email"],
        operator: "contains",
        ignoreCase: true,
      },
      pageSettings: {
        pageSizes: [10, 20, 50, 100],
        pageCount: 5,
        pageSize: 50,
        skip: 0,
        take: 50,
      },
      locale: "",
      treeViewData: [
        { id: "all", text: "Staging Tables", hasChild: true },
        {
          id: "stg_account",
          pid: "all",
          text: "Stg_Account",
        },
      ] as Record<string, any>[],
      scopeTreeSelectedNodes: Array<string>(),
      showPassword: false,
    };
  },
  mounted() {
    this.dataStateChange(
      this.initState(this.pageSettings.skip, this.pageSettings.take)
    );
    this.loadSubscriptions();
    this.loadDbUserType();
    this.loadTreeViewTables();
  },
  methods: {
    initState(skip: number = 0, take: number): any {
      let state = {
        skip: skip,
        take: take,
      };
      return state;
    },
    dataStateChange(state: any) {
      this.pageSettings.skip = state.skip;
      this.pageSettings.take = state.take;
      this.gridLocalize();
      this.loadUser(state);
    },
    async loadUser(state: any) {
      if (state.action) {
        delete state.action;
      }

      var subscriptionId = this.subscriptionId;
      const gridUser: any = this.$refs.gridUser;
      if (gridUser) gridUser.hideSpinner();

      const response = await agent.post<UserGetResponse>(API_KEY.GET_USER, {
        ...state,
        subscriptionId,
      });

      if (response && response.result) {
        this.data = response.result;

        this.data.result.forEach((item: any) => {
          item.showPassword = false;
          item.dummyPassword = "********";
        });
      }
    },
    loadTreeViewTables() {
      const parentNode = { id: "all", text: "Staging Tables", hasChild: true };
      const entities = [
        "Account",
        "CostCenter",
        "Company",
        "Project",
        "Customer",
        "Invoice",
        "Employee",
        "FinancialYear",
        "ActualRevenue",
      ];

      const childNodes = entities.map((entity) => ({
        id: `stg_${entity.toLowerCase()}`,
        pid: "all",
        text: `Stg_${entity}`,
      }));

      this.treeViewData = [parentNode, ...childNodes] as Record<string, any>[];
    },
    onUpsert(event: any) {
      event.preventDefault();

      if (this.isUpdate) {
        this.onEdit();
      } else {
        this.onSave();
      }
    },
    async onSave() {
      const { separatedScopes, separatedEntities } =
        this.prepareScopeAndEntities();

      if (
        this.form.userType == DBUserType.StagingEditor &&
        !separatedEntities
      ) {
        toasterService.warn("Please select at least one table.");
        return;
      }

      this.form.allowedScopes = separatedEntities;

      let post = { ...this.form };
      post.createdBy = authService.getUserEmail();

      const response = await agent.post<UserResponse>(API_KEY.POST, post);
      if (response && response.result) {
        toasterService.success(this.$t("msgSave"));
        this.loadUser(
          this.initState(this.pageSettings.skip, this.pageSettings.take)
        );
        this.resetUser();
        this.close();
      }
    },
    async onEdit() {
      const { separatedScopes, separatedEntities } =
        this.prepareScopeAndEntities();

      if (
        this.form.userType == DBUserType.StagingEditor &&
        !separatedEntities
      ) {
        toasterService.warn("Please select at least one table.");
        return;
      }

      this.form.allowedScopes = separatedEntities;

      let put = { ...this.form };
      put.modifiedBy = authService.getUserEmail();

      const response = await agent.put<UserResponse>(API_KEY.PUT, put);
      if (response && response.result) {
        toasterService.success(this.$t("msgUpdate"));
        this.loadUser(
          this.initState(this.pageSettings.skip, this.pageSettings.take)
        );
        this.resetUser();
        this.close();
      }

      this.resetUser();
    },
    async onDelete(id: number) {
      const response = await agent.delete<UserResponse>(API_KEY.DELETE(id));
      if (response.result) {
        toasterService.success(this.$t("msgDelete"));
        this.loadUser(
          this.initState(this.pageSettings.skip, this.pageSettings.take)
        );
        this.resetUser();
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    resetUser(isNew: boolean = false) {
      var resetValue = {
        subscriptionId: "",
        organizationName: "",
        dbUserId: "",
        dbUserPassword: "",
        allowedIPs: "",
        allowedScopes: "",
        userType: "",
      } as DatabaseUser;

      this.form = { ...resetValue };

      // Need clear the selected cache of dropdown
      setTimeout(() => {
        const ddcustomerInstance: any = this.$refs.customerdd;

        const ddusertypeInstance: any = this.$refs.dbUserdd;

        if (isNew) {
          ddcustomerInstance?.clear();

          ddusertypeInstance?.clear();
        }
      }, 1);

      this.isUpdate = false;

      console.log("user form", this.form);
    },
    async loadSubscriptions() {
      const response = await agent.post<SubscriptionGetResponse>(
        API_KEY.GET_SUBSCRIPTION,
        {}
      );
      if (response && response.result) {
        this.listSubscription = [...response.result.result];
      }
    },
    async loadDbUserType() {
      const response = await agent.get<any>(API_KEY.GET_USERTYPE, {});
      if (response && response.result) {
        this.listUserType = [...response.result];
      }
    },
    onSelectCustomer(event: any) {
      if (event && event.itemData) {
        const id = event.itemData.id;
        // this.loadRoles(id);
      }
    },
    onChangeUserType(event: any) {
      if (event.isInteracted) {
        this.form.allowedScopes = "";
        this.scopeTreeSelectedNodes = [];
      }
    },
    onChangeUserSubscription(event: any) {
      //   this.loadRoles(event.target.value);
    },
    onSubscriptionChange(subscriptionId: string) {
      this.subscriptionId = subscriptionId;

      if (subscriptionId.trim().toLowerCase().indexOf("all") > -1) {
        this.subscriptionId = "";
      }

      this.loadUser(
        this.initState(this.pageSettings.skip, this.pageSettings.take)
      );
    },
    gridLocalize() {
      this.locale = "en-grid";
      if (this.$i18n.locale == "se") {
        setTimeout(() => {
          import(`@/assets/sv.json`).then((module) => {
            const localText = module.default;
            this.locale = "sv";
            setCulture("sv");
            L10n.load(localText);
          });
        });
      }
    },
    commandClick: function (type: string, data: DatabaseUser) {
      this.isUpdate = false;
      const app = this;
      switch (type) {
        case "Delete":
          this.form.id = data.id;
          Confirmation = DialogUtility.confirm({
            title: this.$t("deleteConfiramtion"),
            content: this.$t("msgSureWantToDelete"),
            okButton: {
              text: this.$t("ok"),
              click: async function () {
                Confirmation.hide();
                app.onDelete(app.form.id);
              },
            },
            cancelButton: { text: this.$t("cancel") },
            showCloseIcon: true,
            closeOnEscape: true,
            zIndex: 10000,
            animationSettings: { effect: "Zoom" },
          });
          break;
        case "Edit":
          this.onEditInit(data);
          break;
        default:
          break;
      }
    },
    async onEditInit(form: DatabaseUser) {
      this.resetUser();
      this.form = _.clone(form);

      this.scopeTreeSelectedNodes = this.form.allowedScopes.split(",");
      this.isUpdate = true;
      this.prepareCompanyModalEditView();
      modal.Open("userModal");
    },
    prepareCompanyModalEditView() {
      const existingEntities = this.form.allowedScopes?.split(",") ?? [];
      const selected = existingEntities.filter((e) => e);

      // Also include parent nodes whose every direct child is already selected
      const parentNodes = this.treeViewData.filter((node) => node.hasChild);
      parentNodes.forEach((parent) => {
        const children = this.treeViewData.filter(
          (node) => node.pid === parent.id
        );
        if (
          children.length > 0 &&
          children.every((child) => selected.includes(child.id))
        ) {
          if (!selected.includes(parent.id)) {
            selected.push(parent.id);
          }
        }
      });

      this.scopeTreeSelectedNodes = selected;
    },
    isHost() {
      return authService.isHost();
    },
    open(isNew: boolean = false) {
      this.resetUser(isNew);
      modal.Open("userModal");
    },
    close() {
      this.resetUser();
      modal.Close("userModal");
    },
    getSelectedNodes(): Array<string> {
      return this.scopeTreeSelectedNodes ?? [];
    },
    getAllScopes() {
      return this.treeViewData
        .filter((node) => node.hasChild)
        .map((node) => node.id);
    },
    prepareScopeAndEntities() {
      const scopeList = this.getAllScopes();
      const selectedNodes = this.getSelectedNodes();

      const selectedEntities =
        selectedNodes.filter((node) => !scopeList.includes(node)) ?? [];
      const selectedScopes =
        selectedEntities.map(
          (entity) => this.treeViewData.find((node) => node.id === entity)?.pid
        ) ?? [];

      //
      const separatedScopes = [...new Set(selectedScopes)].join(",");
      const separatedEntities = selectedEntities.join(",");

      return { separatedScopes, separatedEntities };
    },
    copyToClipboard(errorMessage: string) {
      navigator.clipboard.writeText(errorMessage);

      toasterService.success(this.$t("msgCopied"));
    },
    onSearch() {
      const grid = (this.$refs.gridUser as any)?.ej2Instances;
      if (grid) grid.search(this.searchText);
    },
    clearSearch() {
      this.searchText = '';
      const grid = (this.$refs.gridUser as any)?.ej2Instances;
      if (grid) grid.search('');
    },
  },
});
</script>
